// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import { router } from './util/router'

// import pages specific scripts

// import components specific scripts
import './components/accordion'
import './components/google-maps'
import './components/lightgallery'
import './components/mobile-menu'

// Let's route (when the page is ready)!
router.ready()



// WEBPACK FOOTER //
// ./scripts/main.js